// //////////////////////////////////////////////////////////////////////////////////
//
//  ใส่ core และ o365 ด้านหลังเสมอ  api ทำไว้ให้แล้ว เพื่อให้ tablet สามารถใช้งาน depa ได้ด้วย
//
////////////////////////////////////////////////////////////////////////////////////

// export const CORE_API_ENDPOINT = `http://localhost:2000/core`
// export const O365_API_ENDPOINT = `http://localhost:2000/o365`
// export const CORE_SOCKET_ENDPOINT = `/notification/socket`
// export const CORE_SOCKET = `http://localhost:2000`
// export const CORE_FRONTEND = 'http://localhost:2000'


//produc
// export const CORE_API_ENDPOINT = `/api/core`
// export const O365_API_ENDPOINT = `/api/o365`
// export const CORE_SOCKET_ENDPOINT = `/api/notification/socket`
// export const CORE_SOCKET = ``
// export const CORE_FRONTEND = ``

// Dev .9
// export const CORE_API_ENDPOINT = `http://10.0.30.9:8803/api/core`
// export const O365_API_ENDPOINT = `http://10.0.30.9:8803/api/o365`
// export const CORE_SOCKET_ENDPOINT = `/api/notification/socket`
// export const CORE_SOCKET = `http://10.0.30.9:8803`
// export const CORE_FRONTEND = `http://10.0.30.9:8801/api`

// export const CORE_API_ENDPOINT = `https://displayweb.rmbainisys.com/depa/core`
// export const O365_API_ENDPOINT = `https://displayweb.rmbainisys.com/depa/o365`
// export const CORE_SOCKET_ENDPOINT = `/depa/notification/socket`
// export const CORE_SOCKET = `https://displayweb.rmbainisys.com`

//10.0.30.9
// export const CORE_API_ENDPOINT = `/depa/core`
// export const O365_API_ENDPOINT = `/depa/o365`
// export const CORE_SOCKET_ENDPOINT = `/depa/notification/socket`
// export const CORE_SOCKET = ``

//'/api/notification/socket'
// export const CORE_API_ENDPOINT = `https://dtacbainisys.com/core`
// `https://rmdtac.com/core`
// `https://rmdtac-uat2.com/core`
// `https://dtacbainisys.com/core`

//10.0.30.9
// export const CORE_API_ENDPOINT = `http://10.0.30.9:8802/api/core`
// export const O365_API_ENDPOINT = `http://10.0.30.9:8802/api/o365`
// export const CORE_SOCKET_ENDPOINT = `http://10.0.30.9:8802/api/notification/socket`
// export const CORE_SOCKET = ``
// export const CORE_FRONTEND = 'http://10.0.30.9:8802/api'

// export const TIME_BACK_TO_HOME = 60000
// export const TIME_INTERVAL = 60000

//Prod
// export const CORE_API_ENDPOINT = `https://rmtbq.com/api/core`
// export const O365_API_ENDPOINT = `https://rmtbq.com/api/o365`
// export const CORE_SOCKET_ENDPOINT = `https://rmtbq.com/api/notification/socket`
// export const CORE_SOCKET = ``
// export const CORE_FRONTEND = 'https://rmtbq.com/api'
// export const TIME_BACK_TO_HOME = 60000
// export const TIME_INTERVAL = 60000

//Build new 2020
export const CORE_API_ENDPOINT = `/api/core`
export const O365_API_ENDPOINT = `/api/o365`
export const CORE_SOCKET_ENDPOINT = `/api/notification/socket`
export const CORE_SOCKET = ``
export const CORE_FRONTEND = '/api'
export const TIME_BACK_TO_HOME = 60000
export const TIME_INTERVAL = 60000


// WEBPACK FOOTER //
// ./src/display/lib/api.js